"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnsaturation = void 0;
const unsaturationsObject_js_1 = require("chemical-elements/src/unsaturationsObject.js");
/**
 * Simplified version of the calculation in mf-parser
 * @param {string} mf
 * @returns
 */
function getUnsaturation(mf) {
    // split a molecular formula into its elements
    const elements = mf.match(/[A-Z][a-z]*\d*/g);
    let unsaturation = 0;
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const matches = element.match(/([A-Z][a-z]?)(\d*)/);
        const symbol = matches[1];
        const count = matches[2] ? parseInt(matches[2], 10) : 1;
        const elementObject = unsaturationsObject_js_1.unsaturationsObject[symbol];
        if (elementObject === undefined) {
            return undefined;
        }
        unsaturation += unsaturationsObject_js_1.unsaturationsObject[symbol] * count;
    }
    return unsaturation / 2 + 1;
}
exports.getUnsaturation = getUnsaturation;
//# sourceMappingURL=getUnsaturation.js.map